module.exports = __webpack_public_path__ + "weathericons-regular-webfont.1cd48d78f06d33973d9d.woff2";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff2
// module id = ../../../../../src/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff2
// module chunks = styles